var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass,style:({
    background: _vm.containerColor,
    zIndex: _vm.zIndex
  })},[_c('div',{class:_vm.barClass,style:({
      width: (_vm.width + "%"),
      height: _vm.height,
      background: _vm.backgroundColor
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }